import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { format } from "date-fns";

//CUSTOM ELEMENTS
import Area from "../../aGlobalDesign/Area/Area";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import Thumbnail from "../../aGlobalDesign/Avatar/Thumbnail";
import InfoTooltip from "../../aGlobalDesign/Tooltips/Tooltips";
import DatePicker from "../../aGlobalDesign/DatePicker/DatePicker";
import Avatar from "../../aGlobalDesign/Avatar/Avatar";
import dayjs from "dayjs";
import Toggle from "../../aGlobalDesign/Inputs/Toggle";

import {
    Stack,
    Typography
} from "@mui/material";

class Storage extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            isSelectOpen: false,
            renameDialog: null,
            renameDialogText: "",
            maxStorageSize: 10,
            forcePaginationUpdate: 0,
            temporaryElement: null,
            tempEditContent: null,
            showEditTagDialog: false,
            saving: false,
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            zoneList: null,
            callCenterList: null,
            openMessageModal: null,
            openDialogDateSelector: false,
            openDialogFilter: false,
            dateSelected: {
                // 30 days before today
                "Start date": format(new Date(new Date().setDate(new Date().getDate() - 360)).setHours(0, 0, 0, 0), "yyyy-MM-dd HH:mm:ss").toString(),
                // Today
                "End date": format(new Date(), "yyyy-MM-dd HH:mm:ss").toString()
            },
            listToDelete: [],
            selectAll: false
        };
    }

    componentDidMount() {
        this.props.changeAppBarTitle(strings.Storage);
        this.props.ChangeCurrentMenuName("Storage");
        this.props.GetContentSize();
        const maxStorageSize = this.props.currentuser.currentorganization.organizationParameters.find(op => op.key === "Public-MaxStorageSpace");
        if (maxStorageSize === undefined) {this.setState({ maxStorageSize: 10 });}
        else {this.setState({ maxStorageSize: Number(maxStorageSize.value) });}

        const accessRight = this.props.currentuser.accessrights ? this.props.currentuser.accessrights.hasPermission(500, "consult") : 0;
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            tempEditContent: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }

    //#region functions
    ConvertDateForDisplay() {
        const startDate = this.state.dateSelected["Start date"].substring(0, 10);
        const endDate = this.state.dateSelected["End date"].substring(0, 10);

        // extract party of date
        const startDay = startDate.charAt(8) !== "0" ? startDate.slice(8, 10) : startDate.slice(9, 10);
        const endDay = endDate.charAt(8) !== "0" ? endDate.slice(8, 10) : endDate.slice(9, 10);
        const month = endDate.slice(5, 7);
        const yearstart = startDate.slice(0, 4);
        const yearsend = endDate.slice(0, 4);

        const displayDateSelected = startDay === endDay ?
            startDay + "." + month + "." + yearstart
            :
            startDay + "." + month + "." + yearstart + " ‣ " + endDay + "." + month + "." + yearsend;

        return displayDateSelected;
    }
    OndeleteContent(elementsList, onSuccess) {
        this.props.OpenDialog({
            title: strings.confirmDeleteItemContent,
            description: strings.confirmDeleteItemDesc,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteStorage(elementsList, () => {
                    this.forcePaginationUpdate();
                });
            }
        });
    }
    OnLoadClick(element) {
        const temp = this.CreateTemp(element);
        this.setState({
            tempEditContent: element,
            temporaryElement: temp
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            tags: element.tags
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        return element;
    }
    getContentTypes() {
        return [
            { id: 0, name: strings.Messaging },
            { id: 10, name: strings.URL },
            { id: 20, name: strings.imageTitle },
            { id: 30, name: strings.videoTitle },
            { id: 40, name: strings.pdfTitle }
        ];
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : {};
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;

        const tempContentSize = this.props.contents.storageSpace && this.props.contents.storageSpace.temporaryStorage ?
            Math.abs(Math.round( this.props.contents.storageSpace.temporaryStorage.totalBytes * 0.000000001 * 10) / 10) : 0;
        const totalContentSize = this.props.contents.storageSpace && this.props.contents.storageSpace.contentStorage ?
            Math.abs(Math.round( this.props.contents.storageSpace.contentStorage.totalBytes * 0.000000001 * 10) / 10) : 0;
        const totalVideoMessageSize = this.props.contents.storageSpace && this.props.contents.storageSpace.videoMessageStorage ?
            Math.abs(Math.round( this.props.contents.storageSpace.videoMessageStorage.totalBytes * 0.000000001 * 10) / 10) : 0;

        return <>
            <Area
                helmet={strings.helmetStorage}
                title={strings.Storage}
                information={<>
                    <InfoTooltip placement="right"
                        htmlTooltip={
                            <div className="tooltip-storage">
                                <div className="module-tooltip-storage">
                                    <div className="cercle-tooltip-storage" style={{ backgroundColor: "var(--primary-dark)" }}></div>
                                    <p><span>{strings.ContentLibrary}</span> - {Math.abs(Math.round((totalContentSize - tempContentSize) * 10) / 10)}GB</p>
                                </div>
                                <div className="module-tooltip-storage">
                                    <div className="cercle-tooltip-storage" style={{ backgroundColor: "var(--primary-base)" }}></div>
                                    <p><span>{strings.helmetVideo}</span> - {totalVideoMessageSize}GB</p>
                                </div>
                                <div className="module-tooltip-storage">
                                    <div className="cercle-tooltip-storage" style={{ backgroundColor: "var(--primary-medium)" }}></div>
                                    <p><span>{strings.Attachments}</span> - {tempContentSize}GB</p>
                                </div>
                            </div>
                        }
                        htmlElementHover={
                            <Stack alignItems="center" spacing={1} sx={{ marginLeft: "20px" }}>
                                <Stack direction="row" sx={{ minWidth: "200px" }}>
                                    <Typography variant="h5"
                                        color={this.state.totalUsedSize > this.state.maxStorageSize ? "#FF002E" : "#202020"}
                                        sx={{ fontSize: "12px" }}>
                                        <span style={{ fontWeight: 590 }}><b>{strings.used}</b></span> {+ " " + (totalContentSize + totalVideoMessageSize) + "/" + this.state.maxStorageSize + "GB"}
                                    </Typography>
                                </Stack>
                                <div style={{
                                    height: 10,
                                    borderRadius: 5,
                                    width: 200,
                                    backgroundColor: "white",
                                    position: "relative"
                                }}>
                                    <div style={{
                                        position: "absolute",
                                        height: 10,
                                        borderRadius: "5px 0px 0px 5px",
                                        left: 0,
                                        bottom: 0,
                                        width: 200 * (totalContentSize - tempContentSize) / this.state.maxStorageSize,
                                        backgroundColor: "var(--primary-dark)"
                                    }}/>
                                    <div style={{
                                        position: "absolute",
                                        height: 10,
                                        // borderRadius: this.state.usedContentSize === 0 ? "5px 0px 0px 5px" : "0px 0px 0px 0px",
                                        borderRadius: totalContentSize - tempContentSize === 0 ? "5px 0px 0px 5px" : "0px 0px 0px 0px",
                                        left: 200 * (totalContentSize - tempContentSize) / this.state.maxStorageSize,
                                        bottom: 0,
                                        width: 200 * totalVideoMessageSize / this.state.maxStorageSize,
                                        backgroundColor: "var(--primary-base)"
                                    }}/>
                                    <div style={{
                                        position: "absolute",
                                        height: 10,
                                        // borderRadius: this.state.usedContentSize + this.state.externalAPISize === 0 ? "5px 0px 0px 5px" : "0px 0px 0px 0px",
                                        borderRadius: totalContentSize - tempContentSize + totalVideoMessageSize === 0 ? "5px 0px 0px 5px" : "0px 0px 0px 0px",
                                        left: 200 * (totalContentSize - tempContentSize + totalVideoMessageSize) / this.state.maxStorageSize,
                                        bottom: 0,
                                        width: 200 * tempContentSize / this.state.maxStorageSize,
                                        backgroundColor: "var(--primary-medium)"
                                    }}/>
                                </div>
                            </Stack>
                        }/>
                </>}
                sideButtons={
                    [
                        {
                            type: "secondary-icon",
                            onClick: () => { this.setState({ openDialogDateSelector: true }); },
                            nameIcon: "calendar",
                            text: this.ConvertDateForDisplay()
                        },
                        {
                            type: "primary-icon",
                            disabled: this.state.listToDelete.length <= 0,
                            onClick: () => {
                                if (this.state.listToDelete.length > 0) {
                                    this.OndeleteContent(this.state.listToDelete);
                                }
                            },
                            nameIcon: "trash",
                            text: strings.DeleteAll
                        }
                    ]
                }
            >
                <PaginationList
                    forcePaginationUpdate={this.state.forcePaginationUpdate}

                    onGetElements={
                        (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => {
                            const startDate = this.state.dateSelected["Start date"];
                            const endDate = this.state.dateSelected["End date"];
                            this.props.GetStorageList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary, startDate, endDate);
                        }
                    }
                    onSavePagination={this.props.SaveStoragePagination}
                    myElements={this.props.contents.storage}

                    filterOptions={[
                        {
                            filterName: "contenttypeid",
                            filterType: "select",
                            title: strings.SortContentType,
                            list: [
                                { id: 10, name: strings.Messaging },
                                { id: 20, name: strings.content }
                            ]
                        }
                    ]}
                    sortOptions={[
                        { sortName: "lastdatemodified", sortData: "null" },
                        { sortName: "contentTypeName", sortData: "asc" }
                    ]}

                    tableElement={(element) => {
                        const data = element && element.data ? JSON.parse(element.data) : {};
                        const contentType = element ? this.getContentTypes().find(ct => ct.id === element.type) : null;
                        return [
                            {
                                colType: "select",
                                colTitle: "",
                                headerCellRenderer: ({ tableManager, column }) => <div style={{ marginLeft: "20px" }}><Toggle
                                    type="check"
                                    name=""
                                    checked={this.state.selectAll}
                                    onClick={() => {
                                        const newselect = !this.state.selectAll;
                                        const newList = [];
                                        if (newselect) {
                                            this.props.contents.storage.results.forEach(element => {
                                                newList.push({ id: element.id, storageType: element.storageType });
                                            });
                                        }
                                        this.setState({
                                            listToDelete: newList,
                                            selectAll: newselect
                                        });
                                    }}
                                /></div>,
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (value) {
                                        return <Toggle
                                            type="check"
                                            name=""
                                            checked={this.state.listToDelete.findIndex(e => e.id === value.id && e.storageType === value.storageType) >= 0}
                                            onClick={() => {
                                                const index = this.state.listToDelete.findIndex(e => e.id === value.id && e.storageType === value.storageType);
                                                const newList = [...this.state.listToDelete];
                                                if (index < 0) {
                                                    newList.push({ id: value.id, storageType: value.storageType });
                                                }
                                                else {
                                                    newList.splice(index, 1);
                                                }
                                                console.log("listToDelete", newList);
                                                this.setState({ listToDelete: newList });
                                            }}
                                        />;
                                    }
                                    return "";
                                },
                                fixedWidth: "100px",
                                colContent: element ? { id: element.id, storageType: element.storageType } : null,
                                lockWidth: true,
                                justify: "center"
                            },
                            {
                                colTitle: strings.SortContentType,
                                sortIndex: 1,
                                colContent: contentType ? contentType.name : null,
                                fixedWidth: "130px"
                            },
                            {
                                colTitle: strings.SortPreview,
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (value && value.ThumbnailUri) {
                                        return <div style={{ marginTop: "5px", marginBottom: "5px" }}><Thumbnail
                                            href={value.ThumbnailUri}
                                            onClick={() => window.open(value.Uri, "_blank", "rel=noopener noreferrer")}
                                        /></div>;
                                    }
                                    return "";
                                },
                                fixedWidth: "100px",
                                colContent: element && element.data && data.ThumbnailUri ? {
                                    ThumbnailUri: data.ThumbnailUri,
                                    Uri: data.Uri
                                } : null,
                                lockWidth: true,
                                justify: "center"
                            },
                            {
                                colTitle: strings.SortName,
                                colContent: element ? element.storageType === 20 ? element.name : strings.Messaging + "-" + element.name : null,
                                fixedWidth: "250px"
                            },
                            {
                                colTitle: strings.SortDateModified,
                                sortIndex: 0,
                                fixedWidth: "180px",
                                lockWidth: true,
                                colContent: element && element.dateModified ? this.props.parseDate(element.dateModified) : ""
                            },
                            {
                                colTitle: strings.SortCreatedBy,
                                fixedWidth: "150px",
                                cellRenderer: ({ tableManager, stringvalue, field, data, column, colIndex, rowIndex }) => {
                                    const value = data[column.field];
                                    if (!value.agentName || value.agentName === "") {return "";}
                                    return <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
                                        {
                                            value.agentThumbnail ? <Avatar
                                                href={JSON.parse(value.agentThumbnail).PhotoURL}
                                            /> : null
                                        }
                                        {
                                            value.agentName ? <span>{value.agentName}</span> : null
                                        }
                                    </div>;
                                },
                                colContent: element ? {
                                    agentName: element.agentName,
                                    agentThumbnail: element.agentThumbnail
                                } : null
                            },
                            {
                                colTitle: strings.actions,
                                colType: "actions",
                                actions: [1, 2],
                                colContent: [
                                    <ButtonSkaRound
                                        key={"view"}
                                        type={element && element.storageType === 10 && element.hasBeenSeen ? "green" : "primary"}
                                        nameIcon="eye"
                                        onClick={() => {
                                            if (element.storageType === 10 && !element.hasBeenSeen) {
                                                this.props.ViewVideoMessage(element.id, () => {
                                                    this.forcePaginationUpdate();
                                                });
                                            }
                                            const data = element && element.data ? JSON.parse(element.data) : {};
                                            window.open(data.Uri, "_blank", "rel=noopener noreferrer");
                                        }}
                                    />,
                                    <ButtonSkaRound
                                        key={"trash"}
                                        isDisabled={!element || !accessrights
                                            || element.storageType === 20 && accessrights.hasPermission(40, "delete") <= 10
                                            || element.storageType === 10 && accessrights.hasPermission(600, "consult") <= 10 }
                                        type="primary"
                                        nameIcon="trash"
                                        onClick={() => this.OndeleteContent([{ id: element.id, storageType: element.storageType }])}
                                    />
                                ]
                            }
                        ];
                    }}
                />
            </Area>
            <DatePicker open={this.state.openDialogDateSelector}
                blockFutureDates={true}
                onClose={ () => this.setState({ openDialogDateSelector: false }) }
                onValidate={(range) => {
                    const start = dayjs(range.startDate);
                    const end = dayjs(range.endDate);

                    const normalizedStart = start.startOf("day").format("YYYY-MM-DD HH:mm:ss");
                    const normalizedEnd = end.endOf("day").format("YYYY-MM-DD HH:mm:ss");

                    this.setState({
                        dateSelected: {
                            "Start date": normalizedStart,
                            "End date": normalizedEnd
                        },
                        openDialogDateSelector: false
                    }, this.forcePaginationUpdate );
                }}
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(Storage);
